module.exports = __webpack_public_path__ + "img/quoteworx-logo-75.cbf7512d.png";